import React, {
  Suspense,
  useContext,
} from "react";
import "./App.css";
import routes from "./routes";
import {
  Route,
  Routes,
  useLocation,
} from "react-router-dom";
import LoadingAnimation from "./component/loadingComponent/LoadingAnimation";
import { SiteUnitProvider } from "./context/SiteUnitContext";
import { FinancialSeasonProvider } from "./context/FinancialSeasonContext";
import AuthContext from "./services/auth/AuthContext";
import ErrorBoundary from "./component/errorBoundaryComponent/ErrorBoundary";
import GoogleTranslate from "./component/GoogleTranslate";
function App() {
  const location = useLocation();

  const {
    user,
    loading: authLoading,
  } = useContext(AuthContext);

  const authenticatedUserKey =
    user?.id ||
    user?.user_id ||
    user?.email ||
    null;

  return (
    <ErrorBoundary resetKey={location.pathname}>
    <GoogleTranslate />
      <div className="App">
        {authLoading ? (
          <LoadingAnimation />
        ) : (
          <SiteUnitProvider
            key={authenticatedUserKey || "guest"}
            userKey={authenticatedUserKey}
          >
            <FinancialSeasonProvider>
              <Suspense
                fallback={<LoadingAnimation />}
              >
                <Routes>
                  {routes.map((route) => (
                    <Route
                      key={route.path}
                      path={route.path}
                      element={route.element}
                    />
                  ))}
                </Routes>
              </Suspense>
            </FinancialSeasonProvider>
          </SiteUnitProvider>
        )}
      </div>
    </ErrorBoundary>
  );
}

export default App;
